import { useMemo } from 'react';
import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || 'sffs-secret-2025';

export const getCurrentUser = () => {
    try {
        const enc = window.localStorage.getItem('userData');
        if (!enc) return null;
        const bytes = CryptoJS.AES.decrypt(enc, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (_) {
        return null;
    }
};

export const encryptUser = (userData) =>
    CryptoJS.AES.encrypt(JSON.stringify(userData), SECRET_KEY).toString();

const useCurrentUser = () => useMemo(() => getCurrentUser(), []);

export default useCurrentUser;
